/**
 * Wishlist Service
 * Handles wishlist operations
 */

import apiService from '../../../services/apiService';

const WISHLIST_STORAGE_KEY = 'shop_wishlist';

const wishlistService = {
  // Get wishlist from localStorage (for non-authenticated users)
  getLocalWishlist() {
    try {
      const wishlist = localStorage.getItem(WISHLIST_STORAGE_KEY);
      return wishlist ? JSON.parse(wishlist) : [];
    } catch (error) {
      console.error('Error reading wishlist:', error);
      return [];
    }
  },

  // Save wishlist to localStorage
  saveLocalWishlist(items) {
    try {
      localStorage.setItem(WISHLIST_STORAGE_KEY, JSON.stringify(items));
    } catch (error) {
      console.error('Error saving wishlist:', error);
    }
  },

  // Add to local wishlist
  addToLocal(product) {
    const wishlist = this.getLocalWishlist();
    const exists = wishlist.find(item => item.id === product.id);
    
    if (!exists) {
      wishlist.push({
        id: product.id,
        product,
        addedAt: new Date().toISOString()
      });
      this.saveLocalWishlist(wishlist);
    }
    
    return wishlist;
  },

  // Remove from local wishlist
  removeFromLocal(productId) {
    let wishlist = this.getLocalWishlist();
    wishlist = wishlist.filter(item => item.id !== productId);
    this.saveLocalWishlist(wishlist);
    return wishlist;
  },

  // Check if product is in local wishlist
  isInLocalWishlist(productId) {
    const wishlist = this.getLocalWishlist();
    return wishlist.some(item => item.id === productId);
  },

  // Get wishlist from backend (authenticated users)
  async getWishlist() {
    try {
      const response = await apiService.get('/shop/wishlist');
      return response || [];
    } catch (error) {
      console.error('Error fetching wishlist:', error);
      return [];
    }
  },

  // Add to backend wishlist
  async addToWishlist(productId) {
    try {
      await apiService.post('/shop/wishlist', { productId });
      return true;
    } catch (error) {
      console.error('Error adding to wishlist:', error);
      return false;
    }
  },

  // Remove from backend wishlist
  async removeFromWishlist(productId) {
    try {
      await apiService.delete(`/shop/wishlist/${productId}`);
      return true;
    } catch (error) {
      console.error('Error removing from wishlist:', error);
      return false;
    }
  },

  // Clear local wishlist
  clearLocal() {
    localStorage.removeItem(WISHLIST_STORAGE_KEY);
    return [];
  }
};

export default wishlistService;

